export const STORE_ACTION_GET_STORE_LIST = 'STORE_ACTION_GET_STORE_LIST'
export const STORE_SET_FETCHING_STORE_LIST = 'STORE_SET_FETCHING_STORE_LIST'
export const STORE_SET_STORE_LIST = 'STORE_SET_STORE_LIST'
export const STORE_ACTION_GET_ACTIVE_SHIFT = 'STORE_ACTION_GET_ACTIVE_SHIFT'
export const STORE_ACTION_START_SHIFT = 'STORE_ACTION_START_SHIFT'
export const STORE_ACTION_END_SHIFT = 'STORE_ACTION_END_SHIFT'
